import { Component, OnInit } from "@angular/core";
import { FormGroup, Validators, FormBuilder } from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import { ActivatedRoute, Router } from "@angular/router";
import { PhameeService } from "src/app/services/phamee.service";
import * as moment from "moment";
declare var $: any;

@Component({
  selector: "smart-create-crop",
  templateUrl: "./create-crop.component.html",
  styleUrls: [
    "./create-crop.component.css",
    "../platform-color/platform-color.css",
  ],
})
export class CreateCropComponent implements OnInit {
  step: number = 0;
  plotId: string;
  zoneId: string;
  farmId: string;
  PlantingTypeList: any = [];
  BreedTypeList: any = [];
  FormSubmit: FormGroup;
  startDate: any;
  endDate: any;
  minDate: any;
  constructor(
    private phameeService: PhameeService,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.plotId = this.route.snapshot.queryParams["plotId"];
    this.zoneId = this.route.snapshot.queryParams["zoneId"];
    if (this.route.snapshot.queryParams["tab"]) {
      this.step = this.route.snapshot.queryParams["tab"];
    }
    this.FormSubmit = this.fb.group({
      name: ["", Validators.required],
      breedType: ["null", Validators.required],
      plantType: ["null", Validators.required],
      startDate: ["", Validators.required],
      endDate: ["", Validators.required],
      description: [""],
    });
  }

  ngOnInit(): void {
    this.getPlotforMap();
    this.phameeService.getAllbreedType().subscribe(async (success) => {
      if (success.code == 200) {
        let data = success.data;
        data.forEach((element) => {
          this.BreedTypeList.push({
            name: element.name,
            value: element._id,
          });
        });
      }
    });
  }
  getPlotforMap() {
    this.phameeService
      .getPlotbyPlotId(this.plotId)
      .subscribe(async (success) => {
        if (success.code == 200) {
          let data = success.data;
          this.farmId = data[0].farm_id;
        }
      });
  }
  changeBreedType(BreedTypeId) {
    this.PlantingTypeList = [];
    this.FormSubmit.controls["plantType"].setValue("null");

    if (BreedTypeId !== "null") {
      this.spinner.show();
      this.phameeService
        .getPlantTypeByBreedTypeId(BreedTypeId)
        .subscribe(async (success) => {
          if (success.code == 200) {
            let data = success.data;
            data.forEach((element) => {
              this.PlantingTypeList.push({
                name: element.name,
                value: element._id,
                period: element.planting_period_days,
              });
            });
          }
          this.spinner.hide();
        });
    } else {
      this.PlantingTypeList = [];
    }
  }
  selectstartDate(date) {
    if (date) {
      this.minDate = new Date(date);
      this.FormSubmit.controls["endDate"].setValue("");
    }
  }
  selectPlantingType(value) {
    let date;
    if (this.FormSubmit.value.startDate)
      date = new Date(this.FormSubmit.value.startDate);
    else date = new Date();
    this.PlantingTypeList.filter((obj) => {
      if (obj.value == value) {
        this.endDate = new Date(
          moment(date, "YYYY-MM-DD HH:mm:ss", "Asia/Bangkok")
            .add(obj.period, "days")
            .format("YYYY-MM-DD")
        );
      }
    });
  }

  chkConfirmSubmit() {
    if (!this.FormSubmit.invalid) {
      this.spinner.show();
      let arrData = {
        plotId: this.plotId,
        zoneId: this.zoneId,
        data: this.FormSubmit.value,
      };

      sessionStorage.setItem("farmId", this.farmId);

      this.phameeService.createCrop(arrData).subscribe(async (success) => {
        if (success.code == 200) {
          $("#cropSuccessmodal").modal("show");
        } else {
          $("#cropFailmodal").modal("show");
        }
        this.spinner.hide();
      });
    } else {
      $("#cropFailmodal").modal("show");
      this.spinner.hide();
    }
  }

  return_dashboard() {
    this.router.navigate(["/dashboard"]).then(() => {
      window.location.reload();
    });
  }

  create_crop() {
    this.FormSubmit.reset();
    this.step = 1;
  }

  cancel_create_crop() {
    this.FormSubmit.reset();
    this.step = 0;
  }
}
